import HistoramFake from "./histogram";

const CerberusReportFake = ({ withouContainer }) => {
  return (
    <>
      <div className={withouContainer ? "" : "container"}>
        <div className="cerberus__report__fake">
          <HistoramFake />
          <div className="cerberus__report__fake--box">
            <div className="cerberus__report__fake--box--header">
              <div className="skeleton cerberus__report__fake--box--header--text" />
            </div>
            <div className="cerberus__report__fake--box--slot">
              <div className="skeleton cerberus__report__fake--box--slot--text" />
            </div>
            <div className="cerberus__report__fake--box--slot">
              <div className="skeleton cerberus__report__fake--box--slot--text" />
            </div>
            <div className="cerberus__report__fake--box--slot">
              <div className="skeleton cerberus__report__fake--box--slot--text" />
            </div>
            <div className="cerberus__report__fake--box--slot">
              <div className="skeleton cerberus__report__fake--box--slot--text" />
            </div>
            <div className="cerberus__report__fake--box--slot">
              <div className="skeleton cerberus__report__fake--box--slot--text" />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .cerberus__report__fake {
          display: flex;
          flex-direction: column;
          width: 100%;
          &--box {
            display: flex;
            flex-direction: column;
            padding: 1rem;
            border: 1px solid #dfdbd6;
            border-radius: 1rem;
            gap: 1rem;
            &--header {
              border-bottom: 1px solid #f3eeea;
              padding: 1rem 0;
              &--text {
                height: 48px;
                width: 100%;
              }
            }
            &--slot {
              border-bottom: 1px solid #f3eeea;
              padding: 1rem;
              &--text {
                height: 16px;
                width: 100%;
              }
            }
            &--slot:last-child {
              border-bottom: 0;
            }
          }
        }

        @media screen and (min-width: 1024px) {
          .cerberus__report__fake {
            width: 60%;
          }
        }
      `}</style>
    </>
  );
};

export default CerberusReportFake;
